import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

import SoftwareListContainer from 'Pods/Profile/JobsDashboard/Components/SoftwareListContainer'
import ItemsListingWrapper from 'Pods/ItemsListing/ItemsListingWrapper'

function AboutDesigner({ data, popularItems }) {
  return (
    <div className="card card--flat message__content u-mb10">
      <div className="message__designer-info">
        <div className="designer-info__header">
          <strong>About me</strong>
          <a href={data.profileUrl} className="u-float-right">Full profile</a>
        </div>
        <div className="designer-info__stats">
          <div className="designer-info__stats--cell">
            Models <span>{numeral(data.modelsCount).format('0,0')}</span>
          </div>
          <div className="designer-info__stats--cell">
            Response
            {data.responseRate > 0 ? (
              <span>{numeral(data.responseRate).format('0')}% in {data.responseTime}</span>
            ) : (
              <span>-</span>
            )}
          </div>
          <div className="designer-info__stats--cell">
            3D Projects Done
            {data.completedProjectsCount > 0 ? (
              <span>{data.completedProjectsCount}/{data.finishedProjectsCount}</span>
            ) : (
              <span>-</span>
            )}
          </div>
          <div className="designer-info__stats--cell">
            Currently working on {data.activeProjectsCount} 3D Projects.
          </div>
        </div>
        {data.specialities.length > 0 && (
          <div className="job-list-item__row job-list-item__row--bottom">
            <span>Specialties</span>
            <SoftwareListContainer data={data.specialities} />
          </div>
        )}
        <div className="designer-models">
          {popularItems.length > 0 && (
            <div className="designer-info__stats-heading">Some of my models</div>
          )}
          <ItemsListingWrapper gaList="Designer" data={popularItems} perRowType="message" isGalleryEnabled={false} classNames="col-12 col-sm-6 col-lg-4 col-xxl-3" />
        </div>
      </div>
    </div>
  )
}

AboutDesigner.propTypes = {
  data: PropTypes.shape({
    profileUrl: PropTypes.string.isRequired,
    modelsCount: PropTypes.number.isRequired,
    responseRate: PropTypes.number.isRequired,
    responseTime: PropTypes.number.isRequired,
    specialities: PropTypes.array.isRequired,
    completedProjectsCount: PropTypes.number.isRequired,
    finishedProjectsCount: PropTypes.number.isRequired,
  }).isRequired,
  popularItems: PropTypes.array.isRequired,
}

export default AboutDesigner
